import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './ui/styles/ui.css';
import { ThemeProvider as SafiThemeProvider } from 'ui/theme/ThemeContext';
import { ToastProvider as SafiToastProvider } from 'ui/components/Toast';
import { NotifyBridge } from 'ui/extensions/notify';
import KeycloakService from './security/KeycloakService';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root')!);

const LoginError = () => (
	<div className="flex h-screen items-center justify-center bg-[#f8d7da]">
		<h1 className="text-[#721c24]">Hubo un error al cargar el login</h1>
	</div>
);

const renderError = () => {
	root.render(<LoginError />);
};

const renderApp = () => {
	root.render(
		<SafiThemeProvider>
			<SafiToastProvider>
				<NotifyBridge />
				<BrowserRouter>
					<App keycloak={KeycloakService.getKeycloakInstance()} />
				</BrowserRouter>
			</SafiToastProvider>
		</SafiThemeProvider>
	);
};

KeycloakService.init(renderApp, renderError);
